import { axiosInstance } from '~/services';

import type { TypePostUserFindPasswordParams } from '~/types/auth.types';
import type { TypeErrorResponseData } from '~/types/common.types';

const usePostUserFindPassword = () => {
  const endPoint = '/api-owner/user/find/password';

  const postUserFindPassword = async (params: TypePostUserFindPasswordParams) => {
    return axiosInstance
      .post(endPoint, {
        loginId: params.loginId,
        email: params.email,
      })
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postUserFindPassword };
};

export default usePostUserFindPassword;
